import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JournalPage } from './journal';

@NgModule({
  declarations: [
    JournalPage,
  ],
  imports: [
    IonicPageModule.forChild(JournalPage),
  ],
})
export class JournalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/journal/journal.module.ts